import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';

@Component({
    selector: 'zx-search-block',
    templateUrl: './search-block.component.html',
    styleUrls: ['./search-block.component.css']
})
export class SearchBlockComponent implements OnInit {
    validateForm: FormGroup;
    @Input() controlArray = [];
    @Output() onSearch: EventEmitter<any> = new EventEmitter();
    isCollapse = true;

    toggleCollapse() {
        this.isCollapse = !this.isCollapse;
        this.controlArray.forEach((c, index) => {
            c.show = this.isCollapse ? (index < 3) : true;
        })
    }

    resetForm() {
        this.validateForm.reset();
    }

    constructor(private fb: FormBuilder) {
    }

    ngOnInit() {
        console.log(this.controlArray)
        this.validateForm = this.fb.group({});

        for (let i = 0; i < this.controlArray.length; i++) {
            //     console.log(i)
            //     if(i ==10 ) {
            //         break;
            //     }
            //   this.controlArray.push({ index: i, show: i < 3 });
            this.validateForm.addControl(this.controlArray[i].name, new FormControl());
        }
    }

    search() {

    }
}
